import { useFetch } from '../../hooks';
import { getPhones, getShortAgents } from '../../api';

type Result = {
  agents: OptionType[];
  phones: OptionType[];
  initializing: boolean;
};

type FetchResult = Pick<Result, 'agents' | 'phones'>;

export const useCampaignModalOptions = (): Result => {
  const fetchData = useFetch<FetchResult>(async () => {
    const [agentsData, phonesData] = await Promise.all([
      getShortAgents(),
      getPhones(),
    ]);

    const result: FetchResult = {
      agents: agentsData
        .map(item => ({
          value: item.id || '',
          label: item.title || '-',
        }))
        .filter(item => item.value),
      phones: phonesData
        .map(item => ({
          value: item.id || '',
          label: item.phoneNumber || '-',
        }))
        .filter(item => item.value),
    };

    return result;
  });

  return {
    initializing: fetchData.initializing,
    agents: fetchData.data?.agents || [],
    phones: fetchData.data?.phones || [],
  };
};
